import React from 'react'

interface MastercardIconProps {
  width?: number
  height?: number
  className?: string
}

const MastercardIcon: React.FC<MastercardIconProps> = ({
  width = 35,
  height = 24,
  className = ''
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="34"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D9D9D9"
      />
      <g transform="translate(6, 5)">
        <path
          d="M16.1758 0C19.9444 0 23 3.09091 23 6.90332C22.9998 10.7156 19.9443 13.8057 16.1758 13.8057C14.4864 13.8056 12.9416 13.1832 11.75 12.1543C10.5584 13.1832 9.01365 13.8056 7.32422 13.8057C3.55566 13.8057 0.500179 10.7156 0.5 6.90332C0.5 3.09091 3.55555 0 7.32422 0C9.01335 0.000109834 10.5584 0.621855 11.75 1.65039C12.9416 0.621855 14.4866 0.000111238 16.1758 0Z"
          fill="#ED0006"
        />
        <path
          d="M16.1758 0C19.9444 0 23 3.09091 23 6.90332C22.9998 10.7156 19.9443 13.8057 16.1758 13.8057C14.4863 13.8056 12.9416 13.1832 11.75 12.1543C13.2164 10.8882 14.1474 9.00638 14.1475 6.90332C14.1475 4.79982 13.2168 2.91652 11.75 1.65039C12.9416 0.621855 14.4866 0.000111238 16.1758 0Z"
          fill="#F9A000"
        />
        <path
          d="M11.75 1.651C13.2166 2.91712 14.1475 4.79961 14.1475 6.90295C14.1475 9.00606 13.2163 10.8878 11.75 12.1539C10.2837 10.8878 9.35254 9.00604 9.35254 6.90295C9.35255 4.79964 10.2834 2.91712 11.75 1.651Z"
          fill="#FF5E00"
        />
      </g>
    </svg>
  )
}

export default MastercardIcon
